import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ClockIcon = React.forwardRef(function ClockIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C12.5523 5 13 5.44772 13 6V12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H11V6C11 5.44772 11.4477 5 12 5Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

ClockIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ClockIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ClockIcon
